export enum NotificationsButtonType {
  all = 'all',
  unseen = 'unseen'
};